// @flow

import React, { type Node } from 'react';
import { getCountry, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getReceiptAmountLocalTotal } from '@tectonics/prs/receipts/receipt';
import { getMoneyFormat } from '@tectonics/look-and-feel/shopify/commons/money-format';
import { amountToCurrencyString } from '@tectonics/prs/money';
import { useCurrentReceipt } from '@tectonics/prs/receipts';
import { PaymentInfo } from './payment-info';

export function DisplayTotalAmount(): Node {
  const incomingPayment = useIncomingPayment();
  const receipt = useCurrentReceipt();
  const decimalFormat = getMoneyFormat(getCountry(incomingPayment));
  const formatAmount = amountToCurrencyString(decimalFormat);
  return (
    <PaymentInfo label="Valor:" first={true}>
      {formatAmount(getReceiptAmountLocalTotal(receipt))}
    </PaymentInfo>
  );
}
